import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f2a953"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "el-message-box__header"
}
const _hoisted_3 = { class: "el-message-box__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-message-box__close el-icon-close" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "el-message-box__content" }
const _hoisted_7 = { class: "el-message-box__container" }
const _hoisted_8 = {
  key: 1,
  class: "el-message-box__message"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "el-message-box__input" }
const _hoisted_12 = { class: "el-message-box__btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_button = _resolveComponent("ms-button")!
  const _component_el_overlay = _resolveComponent("el-overlay")!
  const _directive_trap_focus = _resolveDirective("trap-focus")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade-in-linear",
    onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('vanish')))
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_overlay, {
        "z-index": _ctx.zIndex,
        "overlay-class": ['is-message-box', _ctx.modalClass],
        mask: _ctx.modal,
        onClick: _withModifiers(_ctx.handleWrapperClick, ["self"])
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            ref: "root",
            "aria-label": _ctx.title || 'dialog',
            "aria-modal": "true",
            class: _normalizeClass([
          'el-message-box',
          _ctx.customClass,
          { 'el-message-box--center': _ctx.center },
        ])
          }, [
            (_ctx.title !== null && _ctx.title !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.icon && _ctx.center)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['el-message-box__status', _ctx.icon])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
                  ]),
                  (_ctx.showClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "el-message-box__headerbtn",
                        "aria-label": "Close",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.handleAction(_ctx.distinguishCancelAndClose ? 'close' : 'cancel')
            )),
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (
              _ctx.handleAction(_ctx.distinguishCancelAndClose ? 'close' : 'cancel')
            ), ["enter"]))
                      }, _hoisted_5, 32))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.icon && !_ctx.center && _ctx.hasMessage)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['el-message-box__status', _ctx.icon])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (_ctx.hasMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "default", {}, () => [
                        (!_ctx.dangerouslyUseHTMLString)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.message), 1))
                          : (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              innerHTML: _ctx.message
                            }, null, 8, _hoisted_10))
                      ], true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "el-message-box__errormsg",
                  style: _normalizeStyle({
                visibility: !!_ctx.editorErrorMessage ? 'visible' : 'hidden',
              })
                }, _toDisplayString(_ctx.editorErrorMessage), 5)
              ], 512), [
                [_vShow, _ctx.showInput]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.showCancelButton)
                ? (_openBlock(), _createBlock(_component_ms_button, {
                    key: 0,
                    loading: _ctx.cancelButtonLoading,
                    class: _normalizeClass([_ctx.cancelButtonClass]),
                    round: _ctx.roundButton,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAction('cancel'))),
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleAction('cancel')), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.cancelButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "class", "round"]))
                : _createCommentVNode("", true),
              (_ctx.showIgnoreButton)
                ? (_openBlock(), _createBlock(_component_ms_button, {
                    key: 1,
                    loading: _ctx.ignoreButtonLoading,
                    class: _normalizeClass([_ctx.ignoreButtonClass]),
                    round: _ctx.roundButton,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAction('ignore'))),
                    onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.handleAction('ignore')), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.ignoreButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "class", "round"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_ms_button, {
                ref: "confirmRef",
                type: "gradient",
                loading: _ctx.confirmButtonLoading,
                class: _normalizeClass([_ctx.confirmButtonClasses]),
                round: _ctx.roundButton,
                disabled: _ctx.confirmButtonDisabled,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleAction('confirm'))),
                onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.handleAction('confirm')), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
                ]),
                _: 1
              }, 8, ["loading", "class", "round", "disabled"]), [
                [_vShow, _ctx.showConfirmButton]
              ])
            ])
          ], 10, _hoisted_1)), [
            [_directive_trap_focus]
          ])
        ]),
        _: 3
      }, 8, ["z-index", "overlay-class", "mask", "onClick"]), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 3
  }))
}